
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqMeliET8E5eH5RR9SqYvrtsrKcvguDtY28XveVTz5FTwMeta } from "/codebuild/output/src824819284/src/src/pages/faq.vue?macro=true";
import { default as menukLvpbaYYvmwp7AaDfm45TBkhiHiG3Lt4WoD95jpdu2wMeta } from "/codebuild/output/src824819284/src/src/pages/menu.vue?macro=true";
import { default as indexIZGev3OhL0hnXrl8tKAzOIqM3c_45vwLDEOKTMtT38EMMMeta } from "/codebuild/output/src824819284/src/src/pages/index.vue?macro=true";
import { default as contacthLXvMrdRFun_SJQn3MxmG0ts5IYclXAv46UZf_45a4V38Meta } from "/codebuild/output/src824819284/src/src/pages/contact.vue?macro=true";
import { default as tutorial1Rh9NRb6DTLCqNrFd7Rm7fjetNUC_ZHJ_PbvTM9BPGsMeta } from "/codebuild/output/src824819284/src/src/pages/tutorial.vue?macro=true";
import { default as agreementlMvlND6HQum8ycwlJKp_45OyULpzkpWKDZ_458VSBAfww3cMeta } from "/codebuild/output/src824819284/src/src/pages/agreement.vue?macro=true";
import { default as about_45passDv_9c8bJ9NnI_457muJpd8kTKRUvTYDuhV7tEuKIwMef4Meta } from "/codebuild/output/src824819284/src/src/pages/about-pass.vue?macro=true";
import { default as indexW5UTNbm4XtrV69ALkeUSegvNkOJFIlZ5oLCeEhvyEt8Meta } from "/codebuild/output/src824819284/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93F5APd27lVt7jFUi5lmBQWWQMpn_KUnZJTLML2qu5KjkMeta } from "/codebuild/output/src824819284/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancelU0EVZs2J_RCG5gHIevp_pBqYLvVMs3JF_45y9J5DLJdEMeta } from "/codebuild/output/src824819284/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93072DEs4wthRVcz_45CRSQBa9FQ073DmR9cjnFvjgC_KREMeta } from "/codebuild/output/src824819284/src/src/pages/notice/[id].vue?macro=true";
import { default as indexJvoRTNxtfFN90qMJMTr8b66aLFzSwBqvuw8JcDUXSkAMeta } from "/codebuild/output/src824819284/src/src/pages/coupon/index.vue?macro=true";
import { default as indexjxWUuaFG4tSK_C9ZgIfnj9U50mXMV_aa40bhNHEBuLgMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/index.vue?macro=true";
import { default as indexk3VueuwWMCZDSTU81E4FwGMOYvlWYq38wvQ3OsUCp7cMeta } from "/codebuild/output/src824819284/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93qf_45R3S2QPbkH9TR0MaPE84KVMt0u0LSkM5FBZqnLmZwMeta } from "/codebuild/output/src824819284/src/src/pages/parking/[id].vue?macro=true";
import { default as indexz_45RR3jfehq0jCsYdKbVdXf26UY94HKR3S086wamRX5cMeta } from "/codebuild/output/src824819284/src/src/pages/history/index.vue?macro=true";
import { default as indexuwqt4dv0WZt6HzbKLDLadhzdgNb_T_SF1zLBMW_6KswMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/index.vue?macro=true";
import { default as indexuOtSSruF57iNVvGoQ0JzGCUwqSmStojhoO4L8H_45N3nwMeta } from "/codebuild/output/src824819284/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexfVrt9TGZvaONBwo1bkiAgO35cMlRiM0jf6YWPUafaH8Meta } from "/codebuild/output/src824819284/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviofBFsMF_pNt0rI1e7GUMiWpLhoYIf_hVN4FdLriwAN4Meta } from "/codebuild/output/src824819284/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editdwdHHFlYbhhNrd6JHWoKEL2a05KYuxidCePqVPhBpUIMeta } from "/codebuild/output/src824819284/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementJDASYyN2m2aZjB_JiMlPQDZoN2e8AT_45dMOXvu_45AaUE0Meta } from "/codebuild/output/src824819284/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexFjQ5LaboyVXvrDi_45VcEZbWwUbBaZ34XXwKoGWlIkL78Meta } from "/codebuild/output/src824819284/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dY1IsYz0xosKjiek6TcnF_fj5Ta_f_45HKYg_45tHdIjLA_45kMeta } from "/codebuild/output/src824819284/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmwQqJ7YtELIbegQShMP5cNiiOauEX8fPkxyq0NfbDfMUMeta } from "/codebuild/output/src824819284/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexlGRVee5V5fdSnZByYQh0OSBXt1OYlSOo0cxhbseFBvIMeta } from "/codebuild/output/src824819284/src/src/pages/card/create/index.vue?macro=true";
import { default as index4RFqCMjjkKygACIcVPwRp1I1z1y4evIdQwGuACjnWcgMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmU1CvtTHn7AIdi3Xn5TXkI_PrvtQ7sH6BB3JilhcaPhgMeta } from "/codebuild/output/src824819284/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm8YJuK94SpLvZGUN19hLe6_45AboAMdIIC_45qICRuadD6d4Meta } from "/codebuild/output/src824819284/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeR3BepHBz_nvobrG_e08ap1WLUa_45kY7Y99Qfg6KEHzD8Meta } from "/codebuild/output/src824819284/src/src/pages/membership/complete.vue?macro=true";
import { default as registerAVxZLDk7HwT2c_QLmDybF1vP_m4Ns0oiIIOiUHQF70YMeta } from "/codebuild/output/src824819284/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93OOvBXe01qFhgP3wlgu4gj_iHL7x8522BmHVUjQHj9BAMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmHXVKzSl_45YUOPqrtMC2eTsRvY1Jtvtfr7afwUvaGx4dMMeta } from "/codebuild/output/src824819284/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93uXDOBn1cOGPFXrY4AamYfKQV3NQGEpp6QmhAfYiaMrAMeta } from "/codebuild/output/src824819284/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexNFmOLn1jJPVmn4bH2ZLo2b2YqGrvS72kKqme06kab8MMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeiy0YjUPLfFKKkOvjCBG5UocTk3PVaqW1kDxXRyl7jLkMeta } from "/codebuild/output/src824819284/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeTfUTFZBSHkEJEX0CzqIjUG5N6YHnHQ2VebLAdDBYHJsMeta } from "/codebuild/output/src824819284/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeXEP4GArN7N_45_HmtggfGptQ4QI2LI_93oXgUszFJCVfMMeta } from "/codebuild/output/src824819284/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register13I8DvkNj_45v_4539N_45_z5GKBtZ8GNqa_45O9cGrlipQ9fSMMeta } from "/codebuild/output/src824819284/src/src/pages/contact-form/register.vue?macro=true";
import { default as completelolgSpVxAT1yXlWrHZ4KEDnpw_45r2YdoQAk1qupOuMwwMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index_zDf7QDzfP6pdVZMk5qoAKdg03tZsAqvZtmGDOnmvHUMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmJpY_45N1JRyuVVcY9ai5APP34DMkmQ9sofH7Q3XW6k3yMMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeB38O1eWK5aAyTs704q_45Bm7Rq_45sFOOJozKVaBGKqO1XgMeta } from "/codebuild/output/src824819284/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexrWIQZ_vzHq014UNXaLC5FNF_70RTfpskFV5ghsWDGP8Meta } from "/codebuild/output/src824819284/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93wX3Gtq17WvwczbbtsaiqRztWWGhshsd_45Ebavbz2ddVUMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completegw0p9q58RnfBayBpFDXDD57zBvUUZWQLTMPsAyFWV0IMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias0BEhRSocD3YDXKqza2hpy0tefJCGrfjSG7Ns94JlZGIMeta } from "/codebuild/output/src824819284/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplekcYTDPK94btyTlHG3fwzJwahCUvnojph_GJcebhboMAMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailHp45kx_45PSSfmI64o93_45eny1YCnMVOCmI1U3jxlzzNG0Meta } from "/codebuild/output/src824819284/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmwP2PEMT3VFa_O3Xt_15TwD8E9cqbShe_HZrPI_hcwToMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentLNOKcgP8MqLdCihV2yCmwNM_NK3lKfSB2TpLiFDw_45TYMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmRbHmNNAQyAzInqwIgny0VEBuoT_0L2vStKPJJhGZDREMeta } from "/codebuild/output/src824819284/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate0xYxPAv5jBah7VxpfOVDZnTFJDhXm9cTSFZvepNiGW4Meta } from "/codebuild/output/src824819284/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeOeM9NBCaYjp_45TRgewk7a3V2AM4NQJ3cquNq23y_45A5a0Meta } from "/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeLyjw2HL8ZnYhjTSMnrMhNyjMQ4izOX6UDh8ixbGJKgkMeta } from "/codebuild/output/src824819284/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordPzE0KU9jI_hBjE5ToOtMcMSkJlAitjLXzwc8tTJECSoMeta } from "/codebuild/output/src824819284/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasfsNeaa2IUR_3eEBBeHdXmgAZ6_ZY9bQ9irL9w7SaS_wMeta } from "/codebuild/output/src824819284/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerYRjYYBxIqeXiGfe_O4fuIH0EMtyO2wIP5Jq920NOzagMeta } from "/codebuild/output/src824819284/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codewxxAMhrA2Njrjhy_45AkBSC5GaMIZmaAc_SmBwW1ReVQEMeta } from "/codebuild/output/src824819284/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexceVHYDHcfmVF_j7vC6GPKYcqTEPanEHfZ4J0IX18jUsMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexaDQqBrtnGyIQLVI6wyZvbkNM57_45iP8IhkYijbI8wSfsMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexQg9gjaE2CflxTcT279_45mh2NunFk3vlMqy5jNpqTUZZsMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexLScmjXxQWZFpBNJILpRLQ3z8pZqD107eT1gd5vJZTJ8Meta } from "/codebuild/output/src824819284/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateEzCEgz0HC3iK86SQZNeTrakv5Fvg3IQthFB_45DlgLXx8Meta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completekrezPh8di3xzjitfVrfmU4jqAVPOmKg1VIFgfGrY1XMMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmks9Ugw7y0sy1CjQT7xi1AG0yyzaUGqdXEMHqvdp_45KfIMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexxtQnvyNuJ677g_NTfUNd5XXkrn_454Fh_4589UfZjly7rJEMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeT0AsLy1XyoXIs_458zyIxJi2jiyceE9l0wpvLQgUp7Zi0Meta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update_XCyrM21ZbG2FBC0qA6ZWPwjJ34KLG_45D8L8K0yuRDCoMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index8F69ew1GHbUqU0siB6ftANr_GW6uQW7AGH_45AM9fDrnIMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index8PqeUvPszeunXHj_aWqbvrrv6rNA15NosYhYYZlVbKkMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeomS9uMKtHvPnG0KWLTMpOl9JasaPhoFZGI_Jk2B1VcEMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index7vzHSwnD8RgSs75S5ijxWVjqcPwhSvvBAKXx0QPFVB0Meta } from "/codebuild/output/src824819284/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeO_0ajHEwz1dkPHNCjbU0S6q4p_45tiBvmYRxAkxp_45DXhYMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index2wr4Vyd997og6Fxeeu59XZCw44sq9QUgRtnP65SyCtkMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexwV12qZSJ9uew5RqhT_45XIRQijki4OTAsWh7eHNMnqiwEMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexqksDqiL7fgwaZkhgZVdxrqQwzzrHW4f9vESqIQJBdMYMeta } from "/codebuild/output/src824819284/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update1TzC3YUQx696dDNgVuY1xhZsya28e097nJNkUBr6nZ8Meta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmfYCl7xjGTwtPgopwyrij_45DpcHaRuhiVFKGeRhkWWm8QMeta } from "/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src824819284/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menukLvpbaYYvmwp7AaDfm45TBkhiHiG3Lt4WoD95jpdu2wMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexIZGev3OhL0hnXrl8tKAzOIqM3c_45vwLDEOKTMtT38EMMMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src824819284/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src824819284/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src824819284/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src824819284/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src824819284/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexJvoRTNxtfFN90qMJMTr8b66aLFzSwBqvuw8JcDUXSkAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexz_45RR3jfehq0jCsYdKbVdXf26UY94HKR3S086wamRX5cMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexuOtSSruF57iNVvGoQ0JzGCUwqSmStojhoO4L8H_45N3nwMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexfVrt9TGZvaONBwo1bkiAgO35cMlRiM0jf6YWPUafaH8Meta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src824819284/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src824819284/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexlGRVee5V5fdSnZByYQh0OSBXt1OYlSOo0cxhbseFBvIMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmU1CvtTHn7AIdi3Xn5TXkI_PrvtQ7sH6BB3JilhcaPhgMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm8YJuK94SpLvZGUN19hLe6_45AboAMdIIC_45qICRuadD6d4Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeR3BepHBz_nvobrG_e08ap1WLUa_45kY7Y99Qfg6KEHzD8Meta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerAVxZLDk7HwT2c_QLmDybF1vP_m4Ns0oiIIOiUHQF70YMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmHXVKzSl_45YUOPqrtMC2eTsRvY1Jtvtfr7afwUvaGx4dMMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeiy0YjUPLfFKKkOvjCBG5UocTk3PVaqW1kDxXRyl7jLkMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeTfUTFZBSHkEJEX0CzqIjUG5N6YHnHQ2VebLAdDBYHJsMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeXEP4GArN7N_45_HmtggfGptQ4QI2LI_93oXgUszFJCVfMMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register13I8DvkNj_45v_4539N_45_z5GKBtZ8GNqa_45O9cGrlipQ9fSMMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmJpY_45N1JRyuVVcY9ai5APP34DMkmQ9sofH7Q3XW6k3yMMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeB38O1eWK5aAyTs704q_45Bm7Rq_45sFOOJozKVaBGKqO1XgMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexrWIQZ_vzHq014UNXaLC5FNF_70RTfpskFV5ghsWDGP8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completegw0p9q58RnfBayBpFDXDD57zBvUUZWQLTMPsAyFWV0IMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplekcYTDPK94btyTlHG3fwzJwahCUvnojph_GJcebhboMAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailHp45kx_45PSSfmI64o93_45eny1YCnMVOCmI1U3jxlzzNG0Meta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmwP2PEMT3VFa_O3Xt_15TwD8E9cqbShe_HZrPI_hcwToMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentLNOKcgP8MqLdCihV2yCmwNM_NK3lKfSB2TpLiFDw_45TYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmRbHmNNAQyAzInqwIgny0VEBuoT_0L2vStKPJJhGZDREMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeOeM9NBCaYjp_45TRgewk7a3V2AM4NQJ3cquNq23y_45A5a0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeLyjw2HL8ZnYhjTSMnrMhNyjMQ4izOX6UDh8ixbGJKgkMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordPzE0KU9jI_hBjE5ToOtMcMSkJlAitjLXzwc8tTJECSoMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src824819284/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerYRjYYBxIqeXiGfe_O4fuIH0EMtyO2wIP5Jq920NOzagMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codewxxAMhrA2Njrjhy_45AkBSC5GaMIZmaAc_SmBwW1ReVQEMeta || {},
    component: () => import("/codebuild/output/src824819284/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src824819284/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src824819284/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]